// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { colorGuard, brandingGuard, languageInfoGuard, signInGuard, signUpGuard, socialSignInGuard, connectorTargetsGuard, customContentGuard, customUiAssetsGuard, customUiCspGuard, partialPasswordPolicyGuard, mfaGuard, adaptiveMfaGuard, captchaPolicyGuard, sentinelPolicyGuard, emailBlocklistPolicyGuard, verificationCodePolicyGuard, forgotPasswordMethodsGuard, passkeySignInGuard, signUpProfileFieldsGuard, passwordExpirationPolicyGuard, usernamePolicyGuard } from './../foundations/index.js';
import { AgreeToTermsPolicy, SignInMode } from './custom-types.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    color: colorGuard,
    branding: brandingGuard,
    hideLogtoBranding: z.boolean().optional(),
    languageInfo: languageInfoGuard,
    termsOfUseUrl: z.string().max(2048).nullable().optional(),
    privacyPolicyUrl: z.string().max(2048).nullable().optional(),
    agreeToTermsPolicy: z.nativeEnum(AgreeToTermsPolicy).optional(),
    signIn: signInGuard,
    signUp: signUpGuard,
    socialSignIn: socialSignInGuard.optional(),
    socialSignInConnectorTargets: connectorTargetsGuard.optional(),
    signInMode: z.nativeEnum(SignInMode).optional(),
    customCss: z.string().nullable().optional(),
    customContent: customContentGuard.optional(),
    customUiAssets: customUiAssetsGuard.nullable().optional(),
    customUiCsp: customUiCspGuard.optional(),
    passwordPolicy: partialPasswordPolicyGuard.optional(),
    mfa: mfaGuard.optional(),
    adaptiveMfa: adaptiveMfaGuard.optional(),
    singleSignOnEnabled: z.boolean().optional(),
    supportEmail: z.string().nullable().optional(),
    supportWebsiteUrl: z.string().nullable().optional(),
    unknownSessionRedirectUrl: z.string().nullable().optional(),
    captchaPolicy: captchaPolicyGuard.optional(),
    sentinelPolicy: sentinelPolicyGuard.optional(),
    emailBlocklistPolicy: emailBlocklistPolicyGuard.optional(),
    verificationCodePolicy: verificationCodePolicyGuard.optional(),
    forgotPasswordMethods: forgotPasswordMethodsGuard.nullable().optional(),
    passkeySignIn: passkeySignInGuard.optional(),
    signUpProfileFields: signUpProfileFieldsGuard.nullable().optional(),
    passwordExpiration: passwordExpirationPolicyGuard.optional(),
    usernamePolicy: usernamePolicyGuard.optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    color: colorGuard,
    branding: brandingGuard,
    hideLogtoBranding: z.boolean(),
    languageInfo: languageInfoGuard,
    termsOfUseUrl: z.string().max(2048).nullable(),
    privacyPolicyUrl: z.string().max(2048).nullable(),
    agreeToTermsPolicy: z.nativeEnum(AgreeToTermsPolicy),
    signIn: signInGuard,
    signUp: signUpGuard,
    socialSignIn: socialSignInGuard,
    socialSignInConnectorTargets: connectorTargetsGuard,
    signInMode: z.nativeEnum(SignInMode),
    customCss: z.string().nullable(),
    customContent: customContentGuard,
    customUiAssets: customUiAssetsGuard.nullable(),
    customUiCsp: customUiCspGuard,
    passwordPolicy: partialPasswordPolicyGuard,
    mfa: mfaGuard,
    adaptiveMfa: adaptiveMfaGuard,
    singleSignOnEnabled: z.boolean(),
    supportEmail: z.string().nullable(),
    supportWebsiteUrl: z.string().nullable(),
    unknownSessionRedirectUrl: z.string().nullable(),
    captchaPolicy: captchaPolicyGuard,
    sentinelPolicy: sentinelPolicyGuard,
    emailBlocklistPolicy: emailBlocklistPolicyGuard,
    verificationCodePolicy: verificationCodePolicyGuard,
    forgotPasswordMethods: forgotPasswordMethodsGuard.nullable(),
    passkeySignIn: passkeySignInGuard,
    signUpProfileFields: signUpProfileFieldsGuard.nullable(),
    passwordExpiration: passwordExpirationPolicyGuard,
    usernamePolicy: usernamePolicyGuard,
});
export const SignInExperiences = Object.freeze({
    table: 'sign_in_experiences',
    tableSingular: 'sign_in_experience',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        color: 'color',
        branding: 'branding',
        hideLogtoBranding: 'hide_logto_branding',
        languageInfo: 'language_info',
        termsOfUseUrl: 'terms_of_use_url',
        privacyPolicyUrl: 'privacy_policy_url',
        agreeToTermsPolicy: 'agree_to_terms_policy',
        signIn: 'sign_in',
        signUp: 'sign_up',
        socialSignIn: 'social_sign_in',
        socialSignInConnectorTargets: 'social_sign_in_connector_targets',
        signInMode: 'sign_in_mode',
        customCss: 'custom_css',
        customContent: 'custom_content',
        customUiAssets: 'custom_ui_assets',
        customUiCsp: 'custom_ui_csp',
        passwordPolicy: 'password_policy',
        mfa: 'mfa',
        adaptiveMfa: 'adaptive_mfa',
        singleSignOnEnabled: 'single_sign_on_enabled',
        supportEmail: 'support_email',
        supportWebsiteUrl: 'support_website_url',
        unknownSessionRedirectUrl: 'unknown_session_redirect_url',
        captchaPolicy: 'captcha_policy',
        sentinelPolicy: 'sentinel_policy',
        emailBlocklistPolicy: 'email_blocklist_policy',
        verificationCodePolicy: 'verification_code_policy',
        forgotPasswordMethods: 'forgot_password_methods',
        passkeySignIn: 'passkey_sign_in',
        signUpProfileFields: 'sign_up_profile_fields',
        passwordExpiration: 'password_expiration',
        usernamePolicy: 'username_policy',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'color',
        'branding',
        'hideLogtoBranding',
        'languageInfo',
        'termsOfUseUrl',
        'privacyPolicyUrl',
        'agreeToTermsPolicy',
        'signIn',
        'signUp',
        'socialSignIn',
        'socialSignInConnectorTargets',
        'signInMode',
        'customCss',
        'customContent',
        'customUiAssets',
        'customUiCsp',
        'passwordPolicy',
        'mfa',
        'adaptiveMfa',
        'singleSignOnEnabled',
        'supportEmail',
        'supportWebsiteUrl',
        'unknownSessionRedirectUrl',
        'captchaPolicy',
        'sentinelPolicy',
        'emailBlocklistPolicy',
        'verificationCodePolicy',
        'forgotPasswordMethods',
        'passkeySignIn',
        'signUpProfileFields',
        'passwordExpiration',
        'usernamePolicy',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
